import React, { Component } from 'react';
import PropTypes from 'prop-types';
import buildContextMenu from '../Common/BuildContextMenu';
import { SearchTypes } from '../../constants/CentricConstants';

import ListView from '../Common/ListView.react';
import ListItem from './CourseListItem.react';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

import CourseActions from '../../actions/CourseActionCreator';
import CourseStore from '../../stores/CourseStore';

class CourseList extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            courses: [],
            actions: buildContextMenu(this.getActions(this.props.id), this.context.auth),
            count: 0,
            page: 0,
            limit: 50,
            searchPage: 0,
            searchMode: false,
            searchText: null,
            loading: false,
            fetchedAll: false,
            showButton: false
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.search = this.search.bind(this);
        this.toggleSearchMode = this.toggleSearchMode.bind(this);
        CourseStore.addChangeListener(this.onChange);
        CourseActions.getAll({limit: this.state.limit});

        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        CourseStore.removeChangeListener(this.onChange);

        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {

        const newEntityUrl = (this.context.auth.isAdmin() ? '/dashboard/course/new' : '');

        return (
            <div ref="courseList">
                <ListView
                    title="Courses"
                    sortOptions={this.props.sortOptions}
                    sortAction={CourseActions.getAll}
                    searchAction={this.search}
                    searchMode={!!this.props.location.query.search}
                    searchType={SearchTypes.COURSES}
                    actions={this.state.actions}
                    items={this.state.courses}
                    itemDecorator={ListItem}
                    newEntityUrl={newEntityUrl}
                    toggleSearchMode={this.toggleSearchMode}
                />
                {this.state.loading && (
                    <LinearProgress mode="indeterminate" />
                )}
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.loading}
                        fullWidth
                    />
                )}
            </div>
        );
    }

    onChange() {
        let courses = CourseStore.getAll();
        if (!!courses) {
            this.setState({courses, loading: false });
        }
        if (CourseStore.fetchedAll()) {
            this.setState({fetchedAll: true});
        }
    }

    getActions() {
        return [
            {
                link: `/logout`,
                label: 'Sign out',
                icon: <CancelIcon />,
            },
        ];
    }

    loadNextPage() {
        if (this.state.loading) { return; } //guard

        const page = !this.state.searchMode ? (this.state.page + 1) : (this.state.searchPage + 1);
        if (!this.state.searchMode) {
            CourseActions.getAll({page, limit: this.state.limit}, false);
            this.setState({page, loading: true});
        } else if (!!this.state.searchText) {
            CourseActions.search(this.state.searchText, {page, limit: this.state.limit});
            this.setState({searchPage: page, loading: true});
        }
    }

    handleScroll() {
        if (!this.state.showButton && window.scrollY > 0) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) >= this.refs.courseList.clientHeight) {
            this.loadNextPage();
        }
    }

    search(searchText) {
        this.timeout && clearTimeout(this.timeout);
        if (!!searchText && searchText.length > 2) {
            this.timeout = setTimeout(() => { CourseActions.search(searchText, {limit: this.state.limit}); }, 500);
            if (searchText !== this.state.searchText) {
                this.setState({fetchedAll: false, showButton: false});
            }
            this.setState({searchText, searchPage: 0});
        }
    }

    toggleSearchMode(searchMode) {
        if (!searchMode) {
            this.setState({searchText: null});
        }
        this.setState({searchMode, fetchedAll: false, showButton: false});
    }
}

CourseList.defaultProps = {
    sortOptions: [
        {label: "Name", value: 'name'},
        {label: "Code", value: 'code'},
        {label: "Created", value: 'dateAdded'}
    ]
};

CourseList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CourseList;